import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateRevisedBudget = async ({
  communityId,
  budgetId,
}: {
  communityId: string;
  budgetId: string;
}) => {
  return await axiosAuth.post(
    `${BUDGET(communityId)}/${budgetId}/revise`
  );
};

const useRevisedBudgetMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateRevisedBudget,
    ...queryParams,
  });

export default useRevisedBudgetMutation;
